import { getGeoIpCountry } from '../api/geoip';

const MIN_COUNTRY_UPDATE = 1000 * 60 * 60;
const FETCH_COUNTRY_TIMEOUT = 1000 * 30;

function fetchCountryInProgress(fetchPromise) {
  return {
    type: 'FETCH_COUNTRY_IN_PROGRESS',
    timestamp: Date.now(),
    fetchPromise,
  };
}

function fetchCountrySuccessful(country) {
  return {
    type: 'FETCH_COUNTRY_SUCCESSFUL',
    timestamp: Date.now(),
    country,
  };
}

function fetchCountryFailed(reason) {
  return {
    type: 'FETCH_COUNTRY_FAILED',
    timestamp: Date.now(),
    reason,
  };
}

function fetchCountry() {
  return (dispatch, getState) => {
    const state = getState();
    const { apiUrl } = state.auth;

    const fetchPromise = getGeoIpCountry(apiUrl).then(
      (geoIP) => {
        if (geoIP && geoIP.country) {
          dispatch(fetchCountrySuccessful(geoIP.country));
          return geoIP.country;
        }
        dispatch(fetchCountryFailed('Could not fetch country'));
        return null;
      },
      (error) => {
        dispatch(fetchCountryFailed(error));
        throw error;
      },
    );

    dispatch(fetchCountryInProgress(fetchPromise));

    return fetchPromise;
  };
}

function shouldFetchCountry(state) {
  const { didInvalidate, fetchingInProgressSince, lastSuccessfulFetch, value } =
    state || {};

  if (!fetchingInProgressSince) {
    if (didInvalidate || !value) {
      return true;
    }

    if (
      !lastSuccessfulFetch ||
      Date.now() - lastSuccessfulFetch > MIN_COUNTRY_UPDATE
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_COUNTRY_TIMEOUT
  ) {
    return true;
  }

  return false;
}

export function fetchCountryIfNeeded() {
  return (dispatch, getState) => {
    const {
      auth: { country },
    } = getState();
    if (shouldFetchCountry(country)) {
      return dispatch(fetchCountry());
    }
    return typeof country?.fetchPromise?.then === 'function'
      ? country.fetchPromise
      : Promise.resolve(country?.value);
  };
}
